import { useEffect, useState } from 'react'

export interface AppUserLite {
  email: string
  username: string
  department: string | null
}

/**
 * Ambil SEMUA user (lintas departemen) dari GET /api/users/all — untuk picker
 * PIC task/subtask yang boleh dari departemen mana pun (+ info departemen).
 */
export function useAllUsers() {
  const [users, setUsers] = useState<AppUserLite[]>([])

  useEffect(() => {
    let active = true
    fetch('/api/users/all')
      .then((r) => (r.ok ? r.json() : []))
      .then((d: unknown) => {
        if (active) setUsers(Array.isArray(d) ? (d as AppUserLite[]) : [])
      })
      .catch(() => { if (active) setUsers([]) })
    return () => { active = false }
  }, [])

  return { users }
}
